import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const ArrowDownThin = (props) => (
  <Icon viewBox="0 0 11 7" {...props}>
    <g>
      <path d="M10.073 1.69L9.345.926 5.073 5.4.802.927l-.729.762 5 5.238z" fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default ArrowDownThin;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/ArrowDownThin.js